<template>
 <div class="eu-flex eu-column eu-row_md">
    <div class="eu-flex-item eu-basis_4_md">
      <div class="emd-form-group">
        <label class="emd-label" for="zipcode">{{ $t('zipcode') }}</label>
        <p class="emd-text">{{ address.zip_code }}</p>
      </div>
    </div>
    <div class="eu-flex-divider"></div>
    <div class="eu-flex-item eu-basis_12">
      <div class="emd-form-group">
        <label class="emd-label" for="street">{{ $t('street') }}</label>
        <p class="emd-text">{{ `${address.street}, ${address.number}` }}</p>
        <p class="emd-text">{{ address.complement }}</p>
      </div>
    </div>
    <div class="eu-flex-item eu-basis_2_md">
      <div class="emd-form-group">
        <label class="emd-label" for="neighborhood">{{ $t('neighborhood') }}</label>
        <p class="emd-text">{{ address.neighborhood }}</p>
      </div>
    </div>
    <div class="eu-flex-item eu-basis_4_md">
      <div class="emd-form-group">
        <label class="emd-label" for="city">{{ $t('city') }}</label>
        <p class="emd-text">{{ `${address.city}, ${address.state} - ${address.country}` }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AddressCard',
  computed: {
    address () {
      return this.$store.getters.address
    }
  }
}
</script>

<i18n>
  {
    "pt-BR": {
      "zipcode": "CEP",
      "street": "Logradouro",
      "neighborhood": "Bairro",
      "city": "Cidade"
    },
    "en-US": {
      "zipcode": "Zip code",
      "street": "Line 1",
      "neighborhood": "Neighborhood",
      "city": "City"
    }
  }
</i18n>
